import React, { useEffect } from 'react';

import Header from '../../components/Header';
import Appfooter from '../../components/Appfooter';
import NewFeedScrollPage from '../../components/Utility/NewFeedScrollPage';
import NewFeed from '../../components/Utility/NewFeed';
import LeftMenu from '../../components/LeftMenu';
import Suggestions from '../../components/Suggestions';
import newUseFeed from '../../hooks/newUseFeed';
import BecomeCreatorBanner from '../../components/BecomeCreatorBanner';
import { isCreator } from '../../signals/creator';

const PopularNewsfeed = () => {
  const {
    feed,
    suggestions,
    isFeedLoading,
    isFeedNextPageLoading,
    loadPreviewPage,
    loadSuggestions,
    onLikePost,
  } = newUseFeed();

  useEffect(() => {
    loadPreviewPage();
    loadSuggestions();
  }, [loadPreviewPage, loadSuggestions]);

  return (
    <div>
      <Header selectedTabIndex={0} isHomePage />
      <LeftMenu />
      <NewFeedScrollPage
        loading={isFeedLoading}
        footerLoading={isFeedNextPageLoading}
        feed={feed}
      >
        <div className="middle-sidebar-bottom fade-in">
          <div className="middle-sidebar-left">
            <div className="row">
              <div className="col-xl-8" style={{ marginBottom: '100px' }}>
                <NewFeed
                  isLoading={isFeedLoading}
                  isNextPageLoading={isFeedNextPageLoading}
                  feed={feed}
                  onLikePost={onLikePost}
                />
              </div>
              <div className="col-xl-4 suggestions">
                <Suggestions suggestionList={suggestions} />
                {!isCreator.value && <BecomeCreatorBanner />}
              </div>
            </div>
          </div>
        </div>
      </NewFeedScrollPage>
      <Appfooter />
    </div>
  );
};

export default PopularNewsfeed;